export const toastTypes = {
  SHOW_TOAST: "SHOW_TOAST",
  HIDE_TOAST: "HIDE_TOAST",

  DISPOSE_TOAST: "DISPOSE_TOAST",
};
